import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EditButton = styled(Button)(({ theme }) => ({
  width: 210,
  height: 32,
  border: `1.5px solid ${theme.palette.secondary.main}`,
  borderRadius: 10,
  color: theme.palette.secondary.main,
  fontWeight: 600,
  backgroundColor: 'transparent',
  display: 'flex',
  gap: 8,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  margin: '20px 0',
  '& span': { color: theme.palette.secondary.main },
}));

export const InputTitle = styled(Typography)(() => ({
  paddingBottom: '4px',
  fontSize: '14px',
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  borderBottom: '1px solid #8B8C8E',
  inlineSize: 'fit-content',
  minWidth: '180px',
  paddingLeft: '8px',
  minHeight: '28px',
}));

export const ButtonContainer = styled(Box)(() => ({
  margin: '20px 0',
  display: 'flex',
  justifyContent: 'space-around',
  gap: '40px',
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '20px',
}));

export const ButtonTitle = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: '600',
  padding: '10px',
}));

type UploadButtonProps = {
  component: string;
};

export const UploadButton = styled(Button)<UploadButtonProps>(
  ({ component }) => ({
    display: 'flex',
    gap: '10px',
    component,
  })
);

export const CepStyle = {
  '& .MuiInputBase-root': {
    borderRadius: '16px',
  },
};

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '60px 0',
  gap: '40px',
}));

export const ConfirmEditButton = styled(Button)(({ theme }) => ({
  minWidth: '250px',
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  marginRight: '20px',
  [theme.breakpoints.down('lg')]: {
    minWidth: '180px',
    maxWidth: '200px',
  },
}));

export const OutlineButton = styled(Button)(({ theme }) => ({
  borderRadius: '16px',
  width: '280px',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  marginTop: '16px',
  fontWeight: '600',
}));
